import React, { useEffect, useState, useRef } from 'react';
interface StatBlockProps {
  number: string;
  label: string;
  className?: string;
}
export function StatBlock({
  number,
  label,
  className = ''
}: StatBlockProps) {
  const [displayNumber, setDisplayNumber] = useState('0');
  const [hasAnimated, setHasAnimated] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = elementRef.current;
    if (!element || hasAnimated) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateNumber();
        }
      });
    }, {
      threshold: 0.3
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [hasAnimated]);
  const animateNumber = () => {
    // Parse the number string to extract numeric value and formatting
    const prefix = number.match(/^[^\d]*/)?.[0] || '';
    const suffix = number.match(/[^\d,]+$/)?.[0] || '';
    const numericString = number.replace(/[^\d]/g, '');
    const targetValue = parseInt(numericString, 10);
    if (isNaN(targetValue)) {
      setDisplayNumber(number);
      return;
    }
    const duration = 1200; // Shorter, fluid animation
    const startTime = performance.now();
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease-in cubic for smooth acceleration
      const easeIn = progress * progress * progress;
      const currentValue = Math.floor(targetValue * easeIn);
      // Format with commas
      const formattedValue = currentValue.toLocaleString('en-US');
      setDisplayNumber(`${prefix}${formattedValue}${suffix}`);
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  };
  return <div ref={elementRef} className={`flex flex-col items-center text-center space-y-2 ${className}`} data-id="element-163" data-mp="2jgg2nmcbjrcf">
      <span className="text-4xl md:text-5xl lg:text-6xl font-bold text-engage-yellow tracking-tight" data-id="element-164" data-mp="kbohbntmeymi">
        {displayNumber}
      </span>
      <span className="text-sm md:text-base font-medium text-engage-white uppercase tracking-wider" data-id="element-165" data-mp="fg95t2j35et9">
        {label}
      </span>
    </div>;
}